module.exports = __webpack_public_path__ + "b96f9b7f444a4774fe03ccaa09135b6b.MP3";